const m = require('minthril');
const { component } = require('../../component');
const { RouteSearch } = require('../../components/route-timeline');
const { HourlyUsageGraph } = require('../../components/hourly-usage-graph');
const { SiteNavigation } = require('../../components/site-navigation');
const { averageDuration, bytes, duration } = require('../../components/usage-totals');

function formatDurationAxis(milliseconds) {
  if (milliseconds === 0) return '0';
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;

  const seconds = milliseconds / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)} s`;

  const minutes = seconds / 60;
  if (minutes < 60) return `${minutes.toFixed(1)} min`;

  return `${(minutes / 60).toFixed(1)} h`;
}

function routeLink(path, detailsHref) {
  return m('a', {
    href: `${detailsHref}?route=${encodeURIComponent(path)}`
  }, m('code', path));
}

function reasonBreakdown(reasons) {
  return Object.entries(reasons || {}).map(([reason, count]) =>
    `${reason.replace(/([A-Z])/g, ' $1').toLowerCase()}: ${count}`
  ).join(' · ');
}

const RoutesPage = component(() => ({
  view: ({ attrs }) => {
    const {
      site,
      stats,
      routes,
      routeDetailsHref,
      backHref = '/sites',
      overviewHref,
      trafficHref,
      routesHref,
      costHref,
      settingsHref
    } = attrs;

    return m('section.panel.site-detail.routes-page', [
      m(SiteNavigation, {
        breadcrumbs: [
          { label: backHref.startsWith('/admin') ? 'Admin' : 'Sites', href: backHref },
          { label: site.name, href: overviewHref },
          { label: 'Routes' }
        ],
        overviewHref,
        trafficHref,
        routesHref,
        costHref,
        settingsHref,
        current: 'routes'
      }),
      m('h2', site.name),
      m('p.routes-page__origin', site.origin),
      stats ? [
        m(HourlyUsageGraph, {
          hourlyUsage: stats.hourlyUsage,
          periodHours: stats.usagePeriodHours,
          metric: 'renderDurationMs',
          title: 'Rendering',
          subtitle: 'Hourly render time across all routes',
          metricLabel: 'Render time',
          formatValue: duration,
          formatAxisValue: formatDurationAxis,
          variant: 'rendering'
        }),
        m(RouteSearch, {
          title: 'Find a route',
          routes,
          detailsHref: routeDetailsHref
        }),
        m('h3', 'Most served routes · last 7 days'),
        stats.routes.length ? m('ol.page-stats.page-stats--routes',
          stats.routes.slice(0, 10).map(route => m('li', { key: route.path }, [
            routeLink(route.path, routeDetailsHref),
            m('span.page-stats-summary', `${route.requests} requests · ${bytes(route.responseBodyBytes)}`),
            route.renders ? m('small.muted.page-stats-detail', `Average render: ${averageDuration(
              route.renderDurationMs,
              route.renders
            )}`) : null,
            Object.keys(route.renderReasons).length ? m('small.muted.page-stats-detail',
              `Render reasons: ${reasonBreakdown(route.renderReasons)}`
            ) : null
          ]))
        ) : m('p.muted', 'No route usage recorded yet.'),
        m('h3', 'Slowest pages'),
        stats.slowestPages.length ? m('ol.page-stats.page-stats--slow',
          stats.slowestPages.map(page => m('li', { key: page.path }, [
            routeLink(page.path, routeDetailsHref),
            m('span.page-stats-summary', page.renderDurationMs || page.timeToLastRequestFinishedMs
              ? `${page.renderDurationMs || page.timeToLastRequestFinishedMs} ms`
              : 'Not recorded')
          ]))
        ) : m('p.muted', 'No page timings recorded yet.')
      ] : m('p.muted', 'Loading routes…')
    ]);
  }
}));

module.exports = { RoutesPage };
